/**
 * services文件api，统一出口
 */
import * as getApi from "./apiData";
export default {
  ...getApi,
};
